










































































import Vue from 'vue';
import { UserRoles } from './modules/auth/auth.model';
import { logout } from './modules/auth/auth.service';
import { InscriptionDeleteRouteName, InscriptionRouteName,InscriptionValideeRouteName, LoginRouteName, InscriptionUpdateRouteName} from './router/index';
import { loginRedirection,interceptResponses } from '@/modules/auth/auth.service';

export default Vue.extend({
  name: 'App',

  components: {
  },

  props: {
  },
  data(){
    return {
        showMenuForAdmin: true,
        isAdmin: false,
        isSiteManager: false,
        isUser: false,
        drawer: null,
        logoutData: {icon:'',text:''},
        links: [ ] as any[]
    }
  },
  methods: {
    logout() {
      logout().then( (res) => {
        this.$router.push('/login');
        this.updateMenu();
      });
    },
    updateMenu(){
      const token = localStorage.getItem('user-token');
      const role = localStorage.getItem('user-role');
      if (role === UserRoles.SITEMNGR.key){
        this.isSiteManager = true;
      }else if (role === UserRoles.ADMIN.key){
        this.isAdmin = true;
      }else if (role === UserRoles.USER.key){
        this.isUser = true;
      }
      if (token) {
        this.logoutData.icon='mdi-logout';
        this.logoutData.text='Se déconnecter';
        if (this.isAdmin){
          this.links = [
                { icon:'mdi-home',text:'Home', route:'/'},
                { icon:'mdi-account',text:'Utilisateurs', route:'/utilisateurs'},
                { icon:'mdi-map-marker-multiple',text:'Sites', route:'/sites'},
                { icon:'mdi-calendar',text:'Evenements', route:'/evenements'},
                { icon:'mdi-home',text:'Test session', route:'/about'}
            ];
          }else{
          this.links = [
                //{ icon:'mdi-map-marker-multiple',text:'Sites', route:'/sites'},
                //TODO enable site mngmt to site managers
                { icon:'mdi-calendar',text:'Evenements', route:'/evenements'}
            ];
          }
      }else{
        this.logoutData.icon='';
        this.logoutData.text='';
        this.links = [
              { icon:'mdi-account',text:'Connexion', route:'/login'}
          ];
        this.showMenuForAdmin = !this.pageIsPublic();
      }
    },
    pageIsPublic(): boolean{
      return this.$route.name === InscriptionRouteName || 
        this.$route.name === InscriptionValideeRouteName || 
        this.$route.name === InscriptionDeleteRouteName || 
        this.$route.name === InscriptionUpdateRouteName;
    },
    pageIsLogin(): boolean{
      return this.$route.name === LoginRouteName ;
    }
  },
  mounted() {
    this.updateMenu();
    if (!this.pageIsPublic()) loginRedirection();
  },
  created: function () {
    interceptResponses();
  }
});
